/**
 * Tiny skeleton shown while a lazy-loaded section's chunk downloads. Reuses the
 * existing scanline/glow aesthetic from PhaserFallback so the visual stays
 * coherent. Most sections load in <100ms on a warm cache; this is only visible
 * on first-tab-tap or cold cache.
 */
export function SectionFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',
        padding: 'var(--space-6)',
        gap: 'var(--space-3)',
      }}
      role="status"
      aria-live="polite"
    >
      <div
        className="label pulse glow-primary"
        style={{ fontSize: '0.7rem', letterSpacing: '0.2em', opacity: 0.8 }}
      >
        ЗАГРУЗКА…
      </div>
      <div
        style={{
          width: '8rem',
          height: 2,
          background: 'rgba(0, 8, 32, 0.6)',
          border: '1px solid var(--fg-primary-dim)',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(90deg, transparent, var(--fg-primary), transparent)',
            animation: 'loader-slide 1.4s linear infinite',
            width: '40%',
          }}
        />
      </div>
    </div>
  );
}
